import { render, staticRenderFns } from "./consumable.vue?vue&type=template&id=7b21b1a0"
import script from "./consumable.ts?vue&type=script&lang=js&external"
export * from "./consumable.ts?vue&type=script&lang=js&external"
import style0 from "./consumable.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports